// import '@src/js/lightgallery.min.js';


$('.gallery-items').lightGallery({
    selector: '.gallery-item',
    thumbnail:true,
    caption     : true,
    desc        : true,
    counter     : false,
    controls    : true,
    preload     : 1,
    toggleThumb: true,
    download: false,

    // Transitions
    mode   : 'lg-slide',
    useCSS : true,
    easing : 'linear',
    speed  : 600,

    // Navigation
    hideControlOnEnd : true,
    loop             : true,
    auto             : true,
    pause            : 2000,
    escKey           : true,
    swipeThreshold    : 50,
});
